<template>
    <div class="about">
        <h1>This is an about page.</h1>
        <AboutText />
    </div>
</template>

<script>
    import AboutText from "../components/AboutText";
    export default {
        name: "AboutView",
        componenets: {
            AboutText,
        },
    };
</script>

<style>
    .about {
        width: 90%;
        margin: auto;
        padding: 150px 0 0 0;
        text-align: center;
    }
</style>
